import { Moon, Sun } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useTheme } from "@/lib/theme";

const btnCls =
  "flex min-h-[42px] items-center justify-center gap-2 rounded-[11px] border border-black/[0.07] bg-white px-3 text-[11.5px] font-bold text-[#171717] transition-colors hover:border-black/25 dark:border-white/[0.10] dark:bg-[#24221e] dark:text-[#f5f2eb] dark:hover:border-white/25";

/** Appearance control at the foot of the menu — the language lives at the top. */
export default function MenuPreferences() {
  const { t, lang } = useLang();
  const { theme, setTheme } = useTheme();
  const es = lang === "es";

  return (
    <div className="mt-1 grid grid-cols-1 gap-1.5">
      <button
        type="button"
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        aria-label={t("tools.appearance")}
        className={btnCls}
      >
        {theme === "dark" ? <Sun aria-hidden="true" className="h-4 w-4" /> : <Moon aria-hidden="true" className="h-4 w-4" />}
        {theme === "dark" ? (es ? "Modo claro" : "Light") : es ? "Modo oscuro" : "Dark"}
      </button>
    </div>
  );
}